interface DrugCardProps {
  drugName: string;
  drugCount: number;
  drugPercentage: number;
  color?: string;
}

const DrugCard = ({
  drugName,
  drugCount,
  drugPercentage,
  color = "#10B981",
}: DrugCardProps) => {
  return (
    <div className="drug-card flex h-14 w-full flex-row items-center justify-between gap-2 rounded-md border-2 border-primaryGray-15 p-3">
      <div className="flex min-w-0 flex-1 flex-row items-center gap-3 text-primaryGray-9">
        <div
          className="mt-0.5 h-3 w-3 flex-shrink-0 rounded-sm"
          style={{ backgroundColor: color }}
        ></div>
        <div className="truncate" title={drugName}>
          {drugName}
        </div>
      </div>
      <div className="flex h-full flex-shrink-0 flex-row items-center justify-end gap-2 text-primaryGray-4">
        <div className="min-w-[2rem] text-right">{drugCount}</div>
        <div className="h-4 w-[1px] bg-primaryGray-4"></div>
        <div className="min-w-[3rem] text-right">{drugPercentage}%</div>
      </div>
    </div>
  );
};

export default DrugCard;
